var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtons1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 42,
    viewBox: "0 0 102 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1709_31137)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 98,
    height: 38,
    rx: 19,
    fill: "#2C963D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9993 14.168V25.8346M25.166 20.0013H36.8327",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2614 26H49.3977L53.5852 14.3636H55.6136L59.8011 26H57.9375L54.6477 16.4773H54.5568L51.2614 26ZM51.5739 21.4432H57.6193V22.9205H51.5739V21.4432ZM64.4716 26.1705C63.767 26.1705 63.1383 25.9905 62.5852 25.6307C62.036 25.267 61.6042 24.75 61.2898 24.0795C60.9792 23.4053 60.8239 22.5966 60.8239 21.6534C60.8239 20.7102 60.9811 19.9034 61.2955 19.233C61.6136 18.5625 62.0492 18.0492 62.6023 17.6932C63.1553 17.3371 63.7822 17.1591 64.483 17.1591C65.0246 17.1591 65.4602 17.25 65.7898 17.4318C66.1231 17.6098 66.3807 17.8182 66.5625 18.0568C66.7481 18.2955 66.892 18.5057 66.9943 18.6875H67.0966V14.3636H68.7955V26H67.1364V24.642H66.9943C66.892 24.8277 66.7443 25.0398 66.5511 25.2784C66.3617 25.517 66.1004 25.7254 65.767 25.9034C65.4337 26.0814 65.0019 26.1705 64.4716 26.1705ZM64.8466 24.7216C65.3352 24.7216 65.7481 24.5928 66.0852 24.3352C66.4261 24.0739 66.6837 23.7121 66.858 23.25C67.036 22.7879 67.125 22.25 67.125 21.6364C67.125 21.0303 67.0379 20.5 66.8636 20.0455C66.6894 19.5909 66.4337 19.2367 66.0966 18.983C65.7595 18.7292 65.3428 18.6023 64.8466 18.6023C64.3352 18.6023 63.9091 18.7348 63.5682 19C63.2273 19.2652 62.9697 19.6269 62.7955 20.0852C62.625 20.5436 62.5398 21.0606 62.5398 21.6364C62.5398 22.2197 62.6269 22.7443 62.8011 23.2102C62.9754 23.6761 63.233 24.0455 63.5739 24.3182C63.9186 24.5871 64.3428 24.7216 64.8466 24.7216ZM74.4872 26.1705C73.7827 26.1705 73.1539 25.9905 72.6009 25.6307C72.0516 25.267 71.6198 24.75 71.3054 24.0795C70.9948 23.4053 70.8395 22.5966 70.8395 21.6534C70.8395 20.7102 70.9967 19.9034 71.3111 19.233C71.6293 18.5625 72.0649 18.0492 72.6179 17.6932C73.1709 17.3371 73.7978 17.1591 74.4986 17.1591C75.0402 17.1591 75.4759 17.25 75.8054 17.4318C76.1387 17.6098 76.3963 17.8182 76.5781 18.0568C76.7637 18.2955 76.9077 18.5057 77.0099 18.6875H77.1122V14.3636H78.8111V26H77.152V24.642H77.0099C76.9077 24.8277 76.7599 25.0398 76.5668 25.2784C76.3774 25.517 76.116 25.7254 75.7827 25.9034C75.4493 26.0814 75.0175 26.1705 74.4872 26.1705ZM74.8622 24.7216C75.3509 24.7216 75.7637 24.5928 76.1009 24.3352C76.4418 24.0739 76.6993 23.7121 76.8736 23.25C77.0516 22.7879 77.1406 22.25 77.1406 21.6364C77.1406 21.0303 77.0535 20.5 76.8793 20.0455C76.705 19.5909 76.4493 19.2367 76.1122 18.983C75.7751 18.7292 75.3584 18.6023 74.8622 18.6023C74.3509 18.6023 73.9247 18.7348 73.5838 19C73.2429 19.2652 72.9853 19.6269 72.8111 20.0852C72.6406 20.5436 72.5554 21.0606 72.5554 21.6364C72.5554 22.2197 72.6425 22.7443 72.8168 23.2102C72.991 23.6761 73.2486 24.0455 73.5895 24.3182C73.9342 24.5871 74.3584 24.7216 74.8622 24.7216Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1709_31137",
    x: 0,
    y: 0,
    width: 102,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1709_31137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1709_31137",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtons1);
export default __webpack_public_path__ + "static/media/Buttons (1).3b3195f05deaea823d485efd601232c7.svg";
export { ForwardRef as ReactComponent };